import { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { useI18n } from '../i18n/index.jsx'
import { GlobalCookieConsent } from '../components/GlobalCookieConsent'

export default function ForgotPassword() {
  const navigate = useNavigate()
  const { t } = useI18n()
  const [email, setEmail] = useState('')
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)
  const [success, setSuccess] = useState(null)

  const onSubmit = async (e) => {
    e.preventDefault()
    setError(null)
    setSuccess(null)

    try {
      setLoading(true)
  const url = `https://lrv7zfe6dc7hrpucp3qulxlzaq0fszlw.lambda-url.eu-west-3.on.aws/auth/forgot_password?email=${encodeURIComponent(email.trim())}`
  const res = await fetch(url, { method: 'POST' })
      const data = await res.json().catch(() => ({}))
      if (!res.ok) {
        setError(data?.detail || data?.error || `HTTP ${res.status}`)
        return
      }
      // Success: { message: "Email de réinitialisation envoyé" }
      setSuccess(data?.message || t('auth.forgot.success'))
      // Rediriger vers la page reset avec l'email pré-rempli
      setTimeout(() => navigate(`/reset-password?email=${encodeURIComponent(email.trim())}`), 1200)
    } catch (err) {
      setError(t('auth.error.server'))
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="relative min-h-screen overflow-hidden bg-gradient-to-br from-slate-950 via-black to-slate-950 text-slate-100">
      <div className="pointer-events-none absolute -top-24 -left-24 h-72 w-72 rounded-full bg-emerald-500/25 blur-3xl hidden md:block" />
      <div className="pointer-events-none absolute bottom-[-90px] right-[-90px] h-96 w-96 rounded-full bg-sky-500/20 blur-3xl hidden md:block" />

      <div className="relative z-10 flex min-h-screen items-center justify-center p-4">
        <div className="w-full max-w-md rounded-2xl border border-white/10 bg-white/5 p-8 shadow-[0_0_1px_rgba(255,255,255,0.25),0_25px_80px_-20px_rgba(16,185,129,0.35)] backdrop-blur-2xl">
          <div className="mb-8 text-center">
            <div className="mx-auto mb-4 h-12 w-12 rounded-full bg-white/10 ring-1 ring-inset ring-blue-400/30" />
            <h1 className="text-2xl font-semibold tracking-tight">{t('auth.forgot.title')}</h1>
            <p className="mt-1 text-sm text-slate-400">{t('auth.forgot.subtitle')}</p>
          </div>

          {error && (
            <div className="mb-4 rounded-lg border border-red-500/30 bg-red-500/10 p-3 text-sm text-red-300">
              {error}
            </div>
          )}
          {success && (
            <div className="mb-4 rounded-lg border border-emerald-500/30 bg-emerald-500/10 p-3 text-sm text-emerald-300">
              {success}
            </div>
          )}

          <form onSubmit={onSubmit} className="space-y-4">
            <div className="space-y-1">
              <label htmlFor="email" className="text-sm text-slate-300">{t('auth.email')}</label>
              <div className="relative">
                <span className="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-slate-400">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="h-5 w-5"><path d="M1.5 8.67v8.58A2.25 2.25 0 0 0 3.75 19.5h16.5a2.25 2.25 0 0 0 2.25-2.25V8.67l-8.724 4.362a3.75 3.75 0 0 1-3.252 0L1.5 8.67Z"/><path d="M22.5 6.908V6.75A2.25 2.25 0 0 0 20.25 4.5H3.75A2.25 2.25 0 0 0 1.5 6.75v.158l9.276 4.64a2.25 2.25 0 0 0 1.948 0L22.5 6.908Z"/></svg>
                </span>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="w-full rounded-lg border border-white/10 bg-white/5 px-10 py-3 text-slate-100 placeholder:text-slate-500 outline-none ring-0 transition focus:border-emerald-500 focus:ring-2 focus:ring-emerald-500/40"
                  placeholder="email@example.com"
                  required
                  disabled={loading}
                />
              </div>
            </div>

            <button
              type="submit"
              disabled={loading}
              className="group mt-6 w-full transform rounded-lg bg-emerald-500 py-3 font-semibold text-slate-950 transition hover:-translate-y-0.5 hover:bg-emerald-400 focus:outline-none focus:ring-2 focus:ring-emerald-500/60 focus:ring-offset-0 disabled:opacity-50"
            >
              {loading ? t('auth.forgot.submitting') : t('auth.forgot.submit')}
              <span className="ml-1 inline-block transition-transform group-hover:translate-x-0.5">→</span>
            </button>
          </form>

          <p className="mt-6 text-center text-sm text-slate-400">
            <Link to="/login" className="text-emerald-400 hover:text-emerald-300">{t('auth.backToLogin')}</Link>
          </p>
        </div>
      </div>

      {/* Cookie Consent */}
      <GlobalCookieConsent />
    </div>
  )
}
